import { useDebounce } from '@scramble/hooks';
import { InvestorDecisionWidget } from '@/containers/InvestorDecisionWidget';

export function AddCashDecisionWidget({ amount, hasInteracted }) {
  const numericAmount = Number(amount);
  const liveAmount =
    hasInteracted && numericAmount > 0 ? numericAmount : undefined;
  const debouncedAmount = useDebounce(liveAmount, 500);
  return <InvestorDecisionWidget placement="addcash" amount={debouncedAmount} />;
}